import React from 'react';
import { useTranslation } from 'react-i18next';
import SeoMeta from '../components/SeoMeta';
import { legalNoticeTranslations } from '../i18n/legal-notice-translations';

const AvisoLegalPage = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'es';
  const t = (key) => legalNoticeTranslations[lang][key] || legalNoticeTranslations['es'][key] || key;

  return (
    <>
      <SeoMeta
        title={t('page-title')}
        description={t('page-description')}
      />

      <div className="bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">
              {t('title')}
            </h1>

            <p className="text-sm text-gray-600 mb-8">
              {t('last-updated')}
            </p>

            {/* 1. Datos Identificativos */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-1-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-1-p1')}</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li><strong>{t('section-1-company')}</strong></li>
                <li>{t('section-1-cif')}</li>
                <li>{t('section-1-address')}</li>
                <li>{t('section-1-email')}</li>
                <li>{t('section-1-registry')}</li>
              </ul>
            </section>

            {/* 2. Objeto del Sitio Web */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-2-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-2-p1')}</p>
              <p className="text-gray-700">{t('section-2-p2')}</p>
            </section>

            {/* 3. Condiciones de Uso */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-3-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-3-p1')}</p>
              <p className="text-gray-700">{t('section-3-p2')}</p>
            </section>

            {/* 4. Propiedad Intelectual */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-4-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-4-p1')}</p>
              <p className="text-gray-700">{t('section-4-p2')}</p>
            </section>

            {/* 5. Plataforma eFTI */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-5-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-5-p1')}</p>
              <p className="text-gray-700 mb-4">{t('section-5-p2')}</p>
              <p className="text-gray-700">{t('section-5-p3')}</p>
            </section>

            {/* 6. Limitación de Responsabilidad */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-6-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-6-p1')}</p>
              <p className="text-gray-700">{t('section-6-p2')}</p>
            </section>

            {/* 7. Protección de Datos */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-7-title')}
              </h2>
              <p className="text-gray-700">{t('section-7-p1')}</p>
            </section>

            {/* 8. Legislación Aplicable */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-8-title')}
              </h2>
              <p className="text-gray-700">{t('section-8-p1')}</p>
            </section>

            {/* Footer */}
            <div className="border-t border-gray-200 pt-6 mt-8">
              <p className="text-sm text-gray-600 mb-2">{t('footer-copyright')}</p>
              <p className="text-sm text-gray-600">
                {t('footer-contact')}{' '}
                <a href={`mailto:${t('footer-email')}`} className="text-blue-600 hover:underline">
                  {t('footer-email')}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AvisoLegalPage;
